/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Players_Waitlist_CountInputs */



/**
* | output |
* | --- |
* | "{count} waitlisted" |
*
* @param {Players_Waitlist_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const players_waitlist_count = /** @type {((inputs: Players_Waitlist_CountInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Players_Waitlist_CountInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} en attente`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} en espera`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.count} em espera`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} in attesa`)
	return /** @type {LocalizedString} */ (`${i?.count} waitlisted`)
});